class OnboardingNavigationCtrl {
  constructor($sce, onboardingDataService) {
    'ngInject';

    this.onboardingDataService = onboardingDataService;
    this.tabs = [];
    this.activeTab = 0;
    this.completedColor = '#42B4B4';
    this.incompleteColor = '#9A86A8';
    this.$sce = $sce;
  }

  trustAs(src) {
    return this.$sce.trustAsHtml(src);
  }

  isOngoing(tabIndex) {
    return tabIndex === this.activeTab;
  }

  isCompleted(tabIndex) {
    return tabIndex < this.lastTabOpen;
  }

  setNavigation(index) {
    if (this.onboardingDataService.isOnboardingSubmitted) {
      return;
    }
    this.getActiveTab({ idx: index });
  }

  displayLockIcon(tabIndex) {
    return (
      this.onboardingDataService.isOnboardingSubmitted &&
      !this.isOngoing(tabIndex)
    );
  }

  $onChanges(changes) {
    if (changes && changes.tabs) {
      this.tabs = changes.tabs.currentValue;
    }
    if (changes && changes.activeTab) {
      this.activeTab = parseInt(changes.activeTab.currentValue, 0);
    }
  }
}

export default OnboardingNavigationCtrl;
